/**
 * ⚠️ ARCHIVO GENERADO — no editar a mano.
 *
 * Se genera desde `referencia/demo-original.html` con:
 *
 *     node scripts/generar-contenido.mjs
 *
 * Cualquier cambio hecho aca se pierde en la siguiente corrida. Para cambiar el contenido
 * en fase 0 hay que tocar la demo original y volver a generar. En fase 1 el contenido pasa
 * a la base y este archivo se convierte en la semilla de la migracion de datos.
 *
 * Se versiona a proposito, aunque sea generado: es el contenido que ve la persona, y tenerlo
 * en el historial es la unica forma de saber despues que vio y en que fecha.
 */
import type { Curso, Espacio, Premio } from '../../domain/types';

export const ESPACIO_BIMBO: Espacio = {
    id: `bimbo`,
    slug: `bimbo`,
    nombre: `Academia Bimbo`,
    cliente: `Bimbo`,
    logoUrl: `/logos/bimbo.png`,
    activo: true,
    tema: {
      azul: `#1E3F94`,
      azulOscuro: `#152C6B`,
      tinta: `#152C6B`,
      rojo: `#E62530`,
      rojoOscuro: `#C41E28`,
      celeste: `#7FC4EC`,
      cielo: `#EAF5FC`,
      oro: `#D99114`,
      verde: `#1E7D4F`,
      borde: `#D7E7F3`,
      gris: `#5E6B85`,
      fuenteTitulos: `'Baloo 2', sans-serif`,
      fuenteTexto: `'Nunito', system-ui, sans-serif`
    }
  };

export const PREMIOS_BIMBO: Premio[] = [
    {
      id: `pr-1`,
      espacioId: `bimbo`,
      icono: `🛒`,
      nombre: `Vale de consumo S/ 30`,
      detalle: `Supermercados afiliados`,
      puntos: 100,
      activo: true,
      orden: 1
    },
    {
      id: `pr-2`,
      espacioId: `bimbo`,
      icono: `🎧`,
      nombre: `Audífonos inalámbricos`,
      detalle: `Entrega con tu supervisor`,
      puntos: 250,
      activo: true,
      orden: 2
    },
    {
      id: `pr-3`,
      espacioId: `bimbo`,
      icono: `🕐`,
      nombre: `Medio día libre`,
      detalle: `Coordinado con operaciones`,
      puntos: 400,
      activo: true,
      orden: 3
    },
    {
      id: `pr-4`,
      espacioId: `bimbo`,
      icono: `🏆`,
      nombre: `Bono del trimestre`,
      detalle: `Top 3 del ranking del equipo`,
      puntos: 600,
      activo: true,
      orden: 4
    }
  ];

const CURSO_TV: Curso = {
    id: `tv`,
    espacioId: `bimbo`,
    slug: `tecnicas-de-ventas`,
    titulo: `Técnicas de Ventas`,
    descripcion: `El método AIDA, escucha activa y cierre: cómo convertir a quien pasa por el pasillo en una venta.`,
    emoji: `🎯`,
    etiqueta: `DISPONIBLE · CURSO DEMO`,
    gradiente1: `#E62530`,
    gradiente2: `#8E0F16`,
    duracionMin: 15,
    orden: 1,
    estado: `publicado`,
    notaMinima: 60,
    insigniaIco: `🏅`,
    insigniaNombre: `Vendedor Experto`,
    lecciones: [
      {
        id: `tv-l1`,
        cursoId: `tv`,
        titulo: `El método AIDA: así decide tu shopper`,
        orden: 1,
        bloques: [
          {
            id: `tv-l1-b1`,
            leccionId: `tv-l1`,
            orden: 1,
            tipo: `presentacion`,
            contenido: {
              modo: `inline`,
              html: `<svg viewBox="0 0 720 240" xmlns="http://www.w3.org/2000/svg">
    <rect width="720" height="240" fill="#10182B"/>
    <circle cx="650" cy="30" r="120" fill="#263576" opacity=".35"/>
    <circle cx="60" cy="220" r="90" fill="#E62530" opacity=".22"/>
    
      <g transform="translate(58,78)">
        <rect width="138" height="86" rx="14" fill="#E62530"/>
        <text x="69" y="38" text-anchor="middle" font-family="Georgia" font-size="30" font-weight="bold" fill="#fff">A</text>
        <text x="69" y="64" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#fff" opacity=".9">ATENCIÓN</text>
      </g>
      <text x="208" y="128" font-size="20" fill="#8C97AF">›</text>
      <g transform="translate(220,78)">
        <rect width="138" height="86" rx="14" fill="#D99114"/>
        <text x="69" y="38" text-anchor="middle" font-family="Georgia" font-size="30" font-weight="bold" fill="#fff">I</text>
        <text x="69" y="64" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#fff" opacity=".9">INTERÉS</text>
      </g>
      <text x="370" y="128" font-size="20" fill="#8C97AF">›</text>
      <g transform="translate(382,78)">
        <rect width="138" height="86" rx="14" fill="#3D55B8"/>
        <text x="69" y="38" text-anchor="middle" font-family="Georgia" font-size="30" font-weight="bold" fill="#fff">D</text>
        <text x="69" y="64" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#fff" opacity=".9">DESEO</text>
      </g>
      <text x="532" y="128" font-size="20" fill="#8C97AF">›</text>
      <g transform="translate(544,78)">
        <rect width="138" height="86" rx="14" fill="#1E7D4F"/>
        <text x="69" y="38" text-anchor="middle" font-family="Georgia" font-size="30" font-weight="bold" fill="#fff">A</text>
        <text x="69" y="64" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#fff" opacity=".9">ACCIÓN</text>
      </g>
      
    <text x="360" y="40" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#8C97AF" letter-spacing="3">EL CAMINO MENTAL DE TODA COMPRA</text>
    <text x="360" y="205" text-anchor="middle" font-family="sans-serif" font-size="12" fill="#C8D2E8">Tu trabajo es acompañar al shopper de una etapa a la siguiente — sin saltarte ninguna.</text>
  </svg>`
            }
          },
          {
            id: `tv-l1-b2`,
            leccionId: `tv-l1`,
            orden: 2,
            tipo: `texto`,
            contenido: {
              html: `<p>Cada persona que pasa frente a tu punto de venta recorre, sin saberlo, un camino mental de cuatro etapas antes de comprar. Ese camino se llama <b>AIDA</b> — Atención, Interés, Deseo y Acción — y es el modelo de ventas más usado del mundo desde hace más de un siglo.</p>
      <div class="destacado"><b>Atención:</b> tienes 3 segundos. Una sonrisa, contacto visual y un saludo con energía detienen a la persona. Un impulsador mirando el celular la deja pasar.</div>
      <p><b>Interés:</b> ya te miró — ahora dale una razón para quedarse. Menciona algo relevante para ella: «Está en promoción esta semana», «Es ideal para las loncheras».</p>
      <p><b>Deseo:</b> conecta el producto con su vida. No digas lo que el producto <i>tiene</i>, di lo que la persona <i>gana</i>: rendimiento, frescura, practicidad, sabor que les encanta a los hijos.</p>
      <p><b>Acción:</b> el paso que casi todos olvidan — <b>pedir la venta</b>. Una invitación simple y directa: «Lléveselo hoy». Sin acción, las tres etapas anteriores no valen nada.</p>`
            }
          }
        ]
      },
      {
        id: `tv-l2`,
        cursoId: `tv`,
        titulo: `Escucha activa: vende quien pregunta`,
        orden: 2,
        bloques: [
          {
            id: `tv-l2-b1`,
            leccionId: `tv-l2`,
            orden: 1,
            tipo: `presentacion`,
            contenido: {
              modo: `inline`,
              html: `<svg viewBox="0 0 720 240" xmlns="http://www.w3.org/2000/svg">
    <rect width="720" height="240" fill="#F1ECE1"/>
    <circle cx="200" cy="125" r="74" fill="#263576"/>
    <circle cx="200" cy="100" r="26" fill="#F6C45A"/>
    <path d="M160 160 q40 -34 80 0 v26 h-80z" fill="#F6C45A"/>
    <g font-family="sans-serif">
      <rect x="318" y="46" rx="16" width="330" height="44" fill="#fff" stroke="#E6E1D5"/>
      <text x="338" y="73" font-size="15" fill="#10182B" font-weight="bold">«¿Qué pan consumen en casa?»</text>
      <rect x="318" y="104" rx="16" width="330" height="44" fill="#263576"/>
      <text x="338" y="131" font-size="15" fill="#fff" font-weight="bold">«¿Busca algo para las loncheras?»</text>
      <rect x="318" y="162" rx="16" width="330" height="44" fill="#E62530"/>
      <text x="338" y="189" font-size="15" fill="#fff" font-weight="bold">Pregunta abierta = conversación abierta</text>
    </g>
  </svg>`
            }
          },
          {
            id: `tv-l2-b2`,
            leccionId: `tv-l2`,
            orden: 2,
            tipo: `texto`,
            contenido: {
              html: `<p>El error más común en el punto de venta es <b>hablar demasiado</b>. Los mejores vendedores hacen lo contrario: preguntan, escuchan y recién entonces recomiendan.</p>
      <div class="destacado">Regla de oro: una <b>pregunta abierta</b> («¿qué pan consumen en casa?») abre conversación. Una pregunta cerrada («¿va a llevar?») invita al «no» y la mata.</div>
      <p>La escucha activa significa prestar atención de verdad a la respuesta: si la persona dice «somos cinco en casa», tu recomendación cambia (presentación familiar, rendimiento). Si dice «estoy cuidando mi salud», también (línea integral, información nutricional).</p>
      <ul>
        <li><b>Pregunta</b> antes de ofrecer: descubre la necesidad real.</li>
        <li><b>Parafrasea</b> lo que escuchaste: «Entonces busca algo que rinda para la semana…».</li>
        <li><b>Recomienda una sola cosa</b>, la correcta — ofrecer cinco productos a la vez confunde y espanta.</li>
      </ul>
      <p>Quien pregunta dirige la conversación. Quien escucha sabe exactamente qué vender.</p>`
            }
          }
        ]
      },
      {
        id: `tv-l3`,
        cursoId: `tv`,
        titulo: `El cierre: pedir la venta sin miedo`,
        orden: 3,
        bloques: [
          {
            id: `tv-l3-b1`,
            leccionId: `tv-l3`,
            orden: 1,
            tipo: `presentacion`,
            contenido: {
              modo: `inline`,
              html: `<svg viewBox="0 0 720 240" xmlns="http://www.w3.org/2000/svg">
    <rect width="720" height="240" fill="#10182B"/>
    <circle cx="80" cy="40" r="100" fill="#1E7D4F" opacity=".25"/>
    <g transform="translate(70,60)" font-family="sans-serif">
      
        <g transform="translate(0,0)">
          <circle cx="16" cy="14" r="15" fill="#E62530"/>
          <text x="16" y="19" text-anchor="middle" font-size="14" font-weight="bold" fill="#fff">1</text>
          <text x="46" y="10" font-size="14.5" font-weight="bold" fill="#fff">Señal de compra</text>
          <text x="46" y="27" font-size="12" fill="#9FB0CE">El shopper pregunta precio, toma el producto, duda en voz alta</text>
        </g>
        <g transform="translate(0,44)">
          <circle cx="16" cy="14" r="15" fill="#E62530"/>
          <text x="16" y="19" text-anchor="middle" font-size="14" font-weight="bold" fill="#fff">2</text>
          <text x="46" y="10" font-size="14.5" font-weight="bold" fill="#fff">Invita a la acción</text>
          <text x="46" y="27" font-size="12" fill="#9FB0CE">«Lléveselo hoy, está en exhibición» — directo y amable</text>
        </g>
        <g transform="translate(0,88)">
          <circle cx="16" cy="14" r="15" fill="#1E7D4F"/>
          <text x="16" y="19" text-anchor="middle" font-size="14" font-weight="bold" fill="#fff">3</text>
          <text x="46" y="10" font-size="14.5" font-weight="bold" fill="#fff">Agradece siempre</text>
          <text x="46" y="27" font-size="12" fill="#9FB0CE">Compre o no: ese shopper vuelve mañana</text>
        </g>
    </g>
    <g transform="translate(560,52)">
      <circle cx="50" cy="60" r="58" fill="#1E7D4F"/>
      <path d="M26 62 l16 16 l34 -36" stroke="#fff" stroke-width="10" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  </svg>`
            }
          },
          {
            id: `tv-l3-b2`,
            leccionId: `tv-l3`,
            orden: 2,
            tipo: `texto`,
            contenido: {
              html: `<p>Está comprobado: la mayoría de ventas perdidas en piso no se pierden por precio ni por producto — se pierden porque <b>nadie invitó a comprar</b>. El cierre es la habilidad más rentable que puedes desarrollar.</p>
      <div class="destacado">Detecta las <b>señales de compra</b>: pregunta el precio, toma el producto, lo compara, duda en voz alta. Cuando aparezcan, no sigas vendiendo — <b>cierra</b>.</div>
      <p>Tres formas simples de cerrar sin presionar:</p>
      <ul>
        <li><b>Cierre directo:</b> «Lléveselo hoy que está en exhibición.»</li>
        <li><b>Cierre de alternativa:</b> «¿Se lleva la presentación grande o la familiar?» — elegir entre dos síes.</li>
        <li><b>Cierre de beneficio:</b> «Con este le alcanza para toda la semana de loncheras.»</li>
      </ul>
      <p>Y si la respuesta es no: <b>agradece con la misma sonrisa</b>. Un «gracias, que tenga buen día» genuino convierte un no de hoy en una compra mañana — y deja bien a la marca, que es exactamente tu trabajo.</p>`
            }
          }
        ]
      }
    ],
    preguntas: [
      {
        id: `tv-q1`,
        cursoId: `tv`,
        enunciado: `¿Qué significan las siglas del método AIDA?`,
        explicacion: `AIDA describe las 4 etapas mentales del comprador: captar su Atención, despertar Interés, generar Deseo y llamar a la Acción.`,
        orden: 1,
        opciones: [
          {
            id: `tv-q1-o1`,
            preguntaId: `tv-q1`,
            texto: `Atención, Interés, Deseo, Acción`,
            orden: 0,
            esCorrecta: true
          },
          {
            id: `tv-q1-o2`,
            preguntaId: `tv-q1`,
            texto: `Actitud, Imagen, Diálogo, Atención`,
            orden: 1
          },
          {
            id: `tv-q1-o3`,
            preguntaId: `tv-q1`,
            texto: `Abordar, Informar, Demostrar, Agradecer`,
            orden: 2
          },
          {
            id: `tv-q1-o4`,
            preguntaId: `tv-q1`,
            texto: `Atención, Información, Decisión, Ahorro`,
            orden: 3
          }
        ]
      },
      {
        id: `tv-q2`,
        cursoId: `tv`,
        enunciado: `Tienes pocos segundos para captar la atención del shopper. ¿Cuál es la mejor forma?`,
        explicacion: `La atención se gana en los primeros 3 segundos con presencia activa: sonrisa, mirada y saludo. La pasividad deja pasar la venta.`,
        orden: 2,
        opciones: [
          {
            id: `tv-q2-o1`,
            preguntaId: `tv-q2`,
            texto: `Esperar a que pregunte algo`,
            orden: 0
          },
          {
            id: `tv-q2-o2`,
            preguntaId: `tv-q2`,
            texto: `Sonreír, hacer contacto visual y saludar con energía`,
            orden: 1,
            esCorrecta: true
          },
          {
            id: `tv-q2-o3`,
            preguntaId: `tv-q2`,
            texto: `Decir el precio en voz alta`,
            orden: 2
          },
          {
            id: `tv-q2-o4`,
            preguntaId: `tv-q2`,
            texto: `Entregarle un volante sin hablar`,
            orden: 3
          }
        ]
      },
      {
        id: `tv-q3`,
        cursoId: `tv`,
        enunciado: `¿Cuál de estas es una pregunta ABIERTA, la que recomienda la escucha activa?`,
        explicacion: `Las preguntas abiertas no se responden con sí/no: te dan información sobre la necesidad real para recomendar lo correcto.`,
        orden: 3,
        opciones: [
          {
            id: `tv-q3-o1`,
            preguntaId: `tv-q3`,
            texto: `«¿Va a llevar?»`,
            orden: 0
          },
          {
            id: `tv-q3-o2`,
            preguntaId: `tv-q3`,
            texto: `«¿Le interesa?»`,
            orden: 1
          },
          {
            id: `tv-q3-o3`,
            preguntaId: `tv-q3`,
            texto: `«¿Qué pan consumen en casa?»`,
            orden: 2,
            esCorrecta: true
          },
          {
            id: `tv-q3-o4`,
            preguntaId: `tv-q3`,
            texto: `«¿Quiere probar sí o no?»`,
            orden: 3
          }
        ]
      },
      {
        id: `tv-q4`,
        cursoId: `tv`,
        enunciado: `El shopper pregunta el precio y toma el producto. ¿Qué deberías hacer?`,
        explicacion: `Preguntar precio y tomar el producto son señales de compra clásicas. Cuando aparecen, se deja de vender y se cierra.`,
        orden: 4,
        opciones: [
          {
            id: `tv-q4-o1`,
            preguntaId: `tv-q4`,
            texto: `Seguir explicando más características`,
            orden: 0
          },
          {
            id: `tv-q4-o2`,
            preguntaId: `tv-q4`,
            texto: `Ofrecerle otros cuatro productos`,
            orden: 1
          },
          {
            id: `tv-q4-o3`,
            preguntaId: `tv-q4`,
            texto: `Reconocer la señal de compra y cerrar: invitarlo a llevarlo`,
            orden: 2,
            esCorrecta: true
          },
          {
            id: `tv-q4-o4`,
            preguntaId: `tv-q4`,
            texto: `Retirarte para no presionar`,
            orden: 3
          }
        ]
      },
      {
        id: `tv-q5`,
        cursoId: `tv`,
        enunciado: `Hiciste todo bien pero el shopper decide no comprar. ¿Cuál es la actitud correcta?`,
        explicacion: `Un no amablemente recibido protege la imagen de la marca y deja la puerta abierta: el cierre de mañana empieza con el gracias de hoy.`,
        orden: 5,
        opciones: [
          {
            id: `tv-q5-o1`,
            preguntaId: `tv-q5`,
            texto: `Insistir una vez más con un descuento inventado`,
            orden: 0
          },
          {
            id: `tv-q5-o2`,
            preguntaId: `tv-q5`,
            texto: `Agradecer con una sonrisa: ese shopper puede volver mañana`,
            orden: 1,
            esCorrecta: true
          },
          {
            id: `tv-q5-o3`,
            preguntaId: `tv-q5`,
            texto: `Comentarle que se pierde una gran oferta`,
            orden: 2
          },
          {
            id: `tv-q5-o4`,
            preguntaId: `tv-q5`,
            texto: `Ignorarlo y abordar al siguiente`,
            orden: 3
          }
        ]
      }
    ]
  };

const CURSO_PP: Curso = {
    id: `pp`,
    espacioId: `bimbo`,
    slug: `portafolio-de-productos`,
    titulo: `Portafolio de Productos`,
    descripcion: `Panes, Cero Cero, Rapiditas, Marinela y panetón: el portafolio Bimbo y el argumento de venta de cada línea.`,
    emoji: `🍞`,
    etiqueta: `DISPONIBLE · NUEVO`,
    gradiente1: `#263576`,
    gradiente2: `#10182B`,
    duracionMin: 15,
    orden: 2,
    estado: `publicado`,
    notaMinima: 60,
    insigniaIco: `🍞`,
    insigniaNombre: `Maestro del Portafolio`,
    lecciones: [
      {
        id: `pp-l1`,
        cursoId: `pp`,
        titulo: `Los panes Bimbo: el corazón de la góndola`,
        orden: 1,
        bloques: [
          {
            id: `pp-l1-b1`,
            leccionId: `pp-l1`,
            orden: 1,
            tipo: `presentacion`,
            contenido: {
              modo: `inline`,
              html: `<svg viewBox="0 0 720 240" xmlns="http://www.w3.org/2000/svg">
    <rect width="720" height="240" fill="#F1ECE1"/>
    <rect x="40" y="186" width="640" height="10" rx="5" fill="#C9BFA8"/>
    <rect x="40" y="96" width="640" height="6" rx="3" fill="#C9BFA8"/>
    
      <g transform="translate(60,112)">
        <rect width="110" height="72" rx="12" fill="#fff" stroke="#E6E1D5"/>
        <path d="M14 34 q41 -28 82 0 v24 h-82z" fill="#E62530" opacity=".85"/>
        <text x="55" y="32" text-anchor="middle" font-family="sans-serif" font-size="10.5" font-weight="bold" fill="#E62530">PAN BLANCO</text>
      </g>
      <g transform="translate(225,112)">
        <rect width="110" height="72" rx="12" fill="#fff" stroke="#E6E1D5"/>
        <path d="M14 34 q41 -28 82 0 v24 h-82z" fill="#8a5a00" opacity=".85"/>
        <text x="55" y="32" text-anchor="middle" font-family="sans-serif" font-size="10.5" font-weight="bold" fill="#8a5a00">INTEGRAL</text>
      </g>
      <g transform="translate(390,112)">
        <rect width="110" height="72" rx="12" fill="#fff" stroke="#E6E1D5"/>
        <path d="M14 34 q41 -28 82 0 v24 h-82z" fill="#1E7D4F" opacity=".85"/>
        <text x="55" y="32" text-anchor="middle" font-family="sans-serif" font-size="10.5" font-weight="bold" fill="#1E7D4F">CERO CERO</text>
      </g>
      <g transform="translate(555,112)">
        <rect width="110" height="72" rx="12" fill="#fff" stroke="#E6E1D5"/>
        <path d="M14 34 q41 -28 82 0 v24 h-82z" fill="#263576" opacity=".85"/>
        <text x="55" y="32" text-anchor="middle" font-family="sans-serif" font-size="10.5" font-weight="bold" fill="#263576">ARTESANO</text>
      </g>
    <text x="360" y="48" text-anchor="middle" font-family="Georgia" font-size="22" font-weight="bold" fill="#10182B">La góndola de panes Bimbo</text>
    <text x="360" y="74" text-anchor="middle" font-family="sans-serif" font-size="12.5" fill="#6B7280">Cada línea responde a una necesidad distinta del shopper — conócelas todas.</text>
  </svg>`
            }
          },
          {
            id: `pp-l1-b2`,
            leccionId: `pp-l1`,
            orden: 2,
            tipo: `texto`,
            contenido: {
              html: `<p>Bimbo opera en el Perú desde 1998 y hoy su góndola de panes es la más completa del mercado. Conocer <b>qué línea responde a qué necesidad</b> es lo que te permite recomendar bien y no perder ninguna venta.</p>
      <ul>
        <li><b>Pan Blanco Bimbo</b> (incluye XL y sin bordes): el clásico familiar. Argumento: suavidad, rendimiento para toda la semana y el favorito de los chicos — la versión sin bordes es perfecta para loncheras.</li>
        <li><b>Pan Integral:</b> para quien busca fibra y alimentación más balanceada sin sacrificar sabor.</li>
        <li><b>Pan Artesano:</b> rebanada más gruesa y textura rústica — ideal para sánguches "de verdad" y desayunos de fin de semana.</li>
        <li><b>Vital:</b> la línea con granos y fibra para el shopper más exigente en nutrición.</li>
      </ul>
      <div class="destacado">La estrella reciente es la <b>familia Cero Cero</b>: pan blanco, pan integral, rapiditas, pan pita y tostadas con <b>0% azúcar añadida y 0% grasas añadidas</b>. Es TU respuesta cuando el shopper dice «estoy cuidando mi alimentación» — antes esa venta se perdía, hoy tiene producto propio.</div>
      <div class="prod-row">
        <div class="prod"><small>Pan Blanco XL 770 g</small></div>
        <div class="prod"><img src="/productos/prod-20570304.jpg" loading="lazy" alt=""><small>Pan Blanco sin Bordes</small></div>
        <div class="prod"><img src="/productos/prod-20127734.jpg" loading="lazy" alt=""><small>Pan Artesano</small></div>
        <div class="prod"><img src="/productos/prod-20283494.jpg" loading="lazy" alt=""><small>Pan Artesano Integral</small></div>
      </div>
      <p>Regla del portafolio: nunca digas «no hay». Si no está el producto exacto que busca, casi siempre existe una línea Bimbo equivalente que ofrecer.</p>`
            }
          }
        ]
      },
      {
        id: `pp-l2`,
        cursoId: `pp`,
        titulo: `Rapiditas, pita y tostadas: el portafolio versátil`,
        orden: 2,
        bloques: [
          {
            id: `pp-l2-b1`,
            leccionId: `pp-l2`,
            orden: 1,
            tipo: `presentacion`,
            contenido: {
              modo: `inline`,
              html: `<svg viewBox="0 0 720 240" xmlns="http://www.w3.org/2000/svg">
    <rect width="720" height="240" fill="#10182B"/>
    <circle cx="640" cy="40" r="110" fill="#D99114" opacity=".2"/>
    
      <g transform="translate(66,60)">
        <rect width="180" height="120" rx="16" fill="#1B2A40"/>
        <text x="90" y="52" text-anchor="middle" font-size="34">🌯</text>
        <text x="90" y="82" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#FFD9A8">RAPIDITAS</text>
        <text x="90" y="102" text-anchor="middle" font-family="sans-serif" font-size="10.5" fill="#C8D2E8">Wraps y fajitas en minutos</text>
      </g>
      <g transform="translate(276,60)">
        <rect width="180" height="120" rx="16" fill="#1B2A40"/>
        <text x="90" y="52" text-anchor="middle" font-size="34">🫓</text>
        <text x="90" y="82" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#FFD9A8">PAN PITA</text>
        <text x="90" y="102" text-anchor="middle" font-family="sans-serif" font-size="10.5" fill="#C8D2E8">Bolsillos rellenos, loncheras</text>
      </g>
      <g transform="translate(486,60)">
        <rect width="180" height="120" rx="16" fill="#1B2A40"/>
        <text x="90" y="52" text-anchor="middle" font-size="34">🍞</text>
        <text x="90" y="82" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#FFD9A8">TOSTADAS</text>
        <text x="90" y="102" text-anchor="middle" font-family="sans-serif" font-size="10.5" fill="#C8D2E8">Desayunos y piqueos crocantes</text>
      </g>
    <text x="360" y="36" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#8C97AF" letter-spacing="3">UN PORTAFOLIO PARA CADA MOMENTO DEL DÍA</text>
    <text x="360" y="212" text-anchor="middle" font-family="sans-serif" font-size="12" fill="#C8D2E8">La venta cruzada vive aquí: quien lleva pan, también desayuna, empaca loncheras y recibe visitas.</text>
  </svg>`
            }
          },
          {
            id: `pp-l2-b2`,
            leccionId: `pp-l2`,
            orden: 2,
            tipo: `texto`,
            contenido: {
              html: `<p>El error común es pensar que Bimbo solo vende pan de molde. Las líneas versátiles abren ocasiones de consumo donde el molde no llega — y son tu mejor herramienta de <b>venta cruzada</b>.</p>
      <ul>
        <li><b>Rapiditas (tortillas):</b> wraps, fajitas y quesadillas en minutos. Argumento: una cena distinta sin cocinar complicado; los chicos las arman solos.</li>
        <li><b>Pan Pita:</b> se abre como bolsillo y se rellena — lonchera práctica y piqueos para visitas.</li>
        <li><b>Tostadas (Bimbo y Pyc):</b> desayuno crocante que no se vence rápido; combinan con dulce y salado.</li>
      </ul>
      <div class="destacado"><b>Venta cruzada en acción:</b> quien lleva pan de molde también desayuna, empaca loncheras y recibe visitas. «¿Y para acompañar la palta? Las tostadas quedan perfectas» — esa frase eleva tu ticket sin presionar.</div>
      <div class="prod-row">
        <div class="prod"><img src="/productos/prod-993739.jpg" loading="lazy" alt=""><small>Rapiditas Clásicas 12 un</small></div>
        <div class="prod"><img src="/productos/prod-20205069.jpg" loading="lazy" alt=""><small>Pan Pita Blanco 10 un</small></div>
        <div class="prod"><img src="/productos/prod-981287.jpg" loading="lazy" alt=""><small>Tostadas Clásicas 10 un</small></div>
      </div>
      <p>Recuerda que varias de estas líneas también existen en versión <b>Cero Cero</b>: rapiditas, pita y tostadas sin azúcar añadida. Un mismo formato, dos argumentos de venta.</p>`
            }
          }
        ]
      },
      {
        id: `pp-l3`,
        cursoId: `pp`,
        titulo: `Marinela, Bimbollos y el panetón: dulce y temporada`,
        orden: 3,
        bloques: [
          {
            id: `pp-l3-b1`,
            leccionId: `pp-l3`,
            orden: 1,
            tipo: `presentacion`,
            contenido: {
              modo: `inline`,
              html: `<svg viewBox="0 0 720 240" xmlns="http://www.w3.org/2000/svg">
    <rect width="720" height="240" fill="#FDF6E8"/>
    <circle cx="90" cy="200" r="80" fill="#E62530" opacity=".12"/>
    <g transform="translate(95,70)">
      <rect width="160" height="110" rx="14" fill="#E62530"/>
      <text x="80" y="48" text-anchor="middle" font-size="34">🧁</text>
      <text x="80" y="82" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#fff">MARINELA</text>
    </g>
    <g transform="translate(280,70)">
      <rect width="160" height="110" rx="14" fill="#263576"/>
      <text x="80" y="48" text-anchor="middle" font-size="34">🍔</text>
      <text x="80" y="82" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#fff">BIMBOLLOS</text>
    </g>
    <g transform="translate(465,70)">
      <rect width="160" height="110" rx="14" fill="#D99114"/>
      <text x="80" y="48" text-anchor="middle" font-size="34">🎄</text>
      <text x="80" y="82" text-anchor="middle" font-family="sans-serif" font-size="13" font-weight="bold" fill="#fff">PANETÓN BIMBO · PYC</text>
    </g>
    <text x="360" y="44" text-anchor="middle" font-family="Georgia" font-size="21" font-weight="bold" fill="#10182B">Dulces, bollería y la campaña del año</text>
    <text x="360" y="214" text-anchor="middle" font-family="sans-serif" font-size="12" fill="#6B7280">Antojo, parrilla y Navidad: tres ocasiones de venta que no dependen del pan de molde.</text>
  </svg>`
            }
          },
          {
            id: `pp-l3-b2`,
            leccionId: `pp-l3`,
            orden: 2,
            tipo: `texto`,
            contenido: {
              html: `<p>El portafolio se completa con tres líneas que venden por <b>antojo y por ocasión</b> — no por rutina. Aquí el abordaje cambia: se vende el momento, no el producto.</p>
      <ul>
        <li><b>Marinela:</b> los pastelitos y bizcochos dulces del grupo. Compra por impulso pura: antojo de la tarde, premio para los chicos. Exhibición y cercanía a caja son clave.</li>
        <li><b>Bimbollos:</b> panes de hamburguesa y hot dog. Su momento es la parrilla, el fin de semana y el partido — pregunta «¿algo para la parrillita?» un viernes y verás.</li>
        <li><b>Panetón Bimbo y Pyc:</b> la campaña más grande del año. En temporada navideña el Perú es uno de los mayores consumidores de panetón del mundo, y llegar primero a la mesa familiar lo es todo.</li>
      </ul>
      <div class="prod-row">
        <div class="prod"><img src="/productos/prod-1673.jpg" loading="lazy" alt=""><small>Gansito Marinela 50 g</small></div>
      </div>
      <div class="destacado"><b>Dato de campo:</b> estas líneas casi nunca se piden — <b>se ofrecen</b>. El shopper no entró buscando un Marinela, pero se lo lleva si tú conectas el producto con su momento: el antojo, la parrilla, la Navidad.</div>`
            }
          }
        ]
      }
    ],
    preguntas: [
      {
        id: `pp-q1`,
        cursoId: `pp`,
        enunciado: `El shopper te dice «estoy cuidando mi alimentación, casi no como pan». ¿Qué línea le ofreces?`,
        explicacion: `La familia Cero Cero (pan blanco, integral, rapiditas, pita y tostadas) existe exactamente para no perder al shopper que cuida su alimentación.`,
        orden: 1,
        opciones: [
          {
            id: `pp-q1-o1`,
            preguntaId: `pp-q1`,
            texto: `Pan Artesano`,
            orden: 0
          },
          {
            id: `pp-q1-o2`,
            preguntaId: `pp-q1`,
            texto: `La familia Cero Cero: 0% azúcar añadida y 0% grasas añadidas`,
            orden: 1,
            esCorrecta: true
          },
          {
            id: `pp-q1-o3`,
            preguntaId: `pp-q1`,
            texto: `Bimbollos`,
            orden: 2
          },
          {
            id: `pp-q1-o4`,
            preguntaId: `pp-q1`,
            texto: `Marinela`,
            orden: 3
          }
        ]
      },
      {
        id: `pp-q2`,
        cursoId: `pp`,
        enunciado: `¿Cuál es el argumento de venta del pan Bimbo sin bordes?`,
        explicacion: `El sin bordes resuelve un dolor real de las mamás: loncheras sin desperdicio y sin reclamos de los chicos.`,
        orden: 2,
        opciones: [
          {
            id: `pp-q2-o1`,
            preguntaId: `pp-q2`,
            texto: `Es el más barato de la góndola`,
            orden: 0
          },
          {
            id: `pp-q2-o2`,
            preguntaId: `pp-q2`,
            texto: `Perfecto para loncheras: a los chicos no les gustan los bordes`,
            orden: 1,
            esCorrecta: true
          },
          {
            id: `pp-q2-o3`,
            preguntaId: `pp-q2`,
            texto: `Dura más que los demás`,
            orden: 2
          },
          {
            id: `pp-q2-o4`,
            preguntaId: `pp-q2`,
            texto: `Viene con sorpresa`,
            orden: 3
          }
        ]
      },
      {
        id: `pp-q3`,
        cursoId: `pp`,
        enunciado: `Una clienta lleva palta y huevos. ¿Cuál es la mejor venta cruzada del portafolio?`,
        explicacion: `La venta cruzada conecta lo que ya compra con un producto del portafolio. Tostadas + palta es un clásico peruano que se vende solo.`,
        orden: 3,
        opciones: [
          {
            id: `pp-q3-o1`,
            preguntaId: `pp-q3`,
            texto: `Un panetón`,
            orden: 0
          },
          {
            id: `pp-q3-o2`,
            preguntaId: `pp-q3`,
            texto: `Ofrecerle tostadas: «quedan perfectas con la palta»`,
            orden: 1,
            esCorrecta: true
          },
          {
            id: `pp-q3-o3`,
            preguntaId: `pp-q3`,
            texto: `Otro paquete de lo mismo`,
            orden: 2
          },
          {
            id: `pp-q3-o4`,
            preguntaId: `pp-q3`,
            texto: `No decir nada, ya está comprando`,
            orden: 3
          }
        ]
      },
      {
        id: `pp-q4`,
        cursoId: `pp`,
        enunciado: `¿Qué hace especiales a las Rapiditas dentro del portafolio?`,
        explicacion: `Rapiditas abre una ocasión de consumo que el pan de molde no cubre: comidas rápidas y versátiles que los chicos pueden armar solos.`,
        orden: 4,
        opciones: [
          {
            id: `pp-q4-o1`,
            preguntaId: `pp-q4`,
            texto: `Son tortillas para wraps y fajitas: cenas rápidas y distintas`,
            orden: 0,
            esCorrecta: true
          },
          {
            id: `pp-q4-o2`,
            preguntaId: `pp-q4`,
            texto: `Son un pan dulce de temporada`,
            orden: 1
          },
          {
            id: `pp-q4-o3`,
            preguntaId: `pp-q4`,
            texto: `Solo se venden en Navidad`,
            orden: 2
          },
          {
            id: `pp-q4-o4`,
            preguntaId: `pp-q4`,
            texto: `Son exclusivas del canal tradicional`,
            orden: 3
          }
        ]
      },
      {
        id: `pp-q5`,
        cursoId: `pp`,
        enunciado: `Sobre Marinela, Bimbollos y el panetón, ¿cuál es la clave de venta?`,
        explicacion: `Son compras de impulso y de ocasión: el shopper no vino por ellas, pero se las lleva cuando conectas el producto con su momento.`,
        orden: 5,
        opciones: [
          {
            id: `pp-q5-o1`,
            preguntaId: `pp-q5`,
            texto: `Esperar a que el shopper los pida`,
            orden: 0
          },
          {
            id: `pp-q5-o2`,
            preguntaId: `pp-q5`,
            texto: `Se venden por momento u ocasión: antojo, parrilla, Navidad — se ofrecen, no se piden`,
            orden: 1,
            esCorrecta: true
          },
          {
            id: `pp-q5-o3`,
            preguntaId: `pp-q5`,
            texto: `Solo se venden con descuento`,
            orden: 2
          },
          {
            id: `pp-q5-o4`,
            preguntaId: `pp-q5`,
            texto: `Recomendarlos únicamente a clientes frecuentes`,
            orden: 3
          }
        ]
      }
    ]
  };

/** Los dos que la demo muestra con candado: se ven en la ruta, no se pueden tomar. */
const CURSO_EC: Curso = {
    id: `ec`,
    espacioId: `bimbo`,
    slug: `experiencia-del-cliente`,
    titulo: `Experiencia del Cliente`,
    descripcion: `Abordaje en piso de venta, manejo de objeciones y cómo dejar huella positiva de la marca.`,
    emoji: `🤝`,
    etiqueta: `PRÓXIMAMENTE`,
    gradiente1: `#D99114`,
    gradiente2: `#8a5a00`,
    duracionMin: 18,
    orden: 3,
    estado: `proximamente`,
    notaMinima: 60,
    insigniaIco: `🤝`,
    insigniaNombre: `Embajador de Marca`,
    leccionesPrevistas: 4,
    preguntasPrevistas: 5,
    lecciones: [],
    preguntas: []
  };

const CURSO_NT: Curso = {
    id: `nt`,
    espacioId: `bimbo`,
    slug: `normas-y-procesos`,
    titulo: `Normas y Procesos en Tienda`,
    descripcion: `Reglas del canal moderno y tradicional: registro, planogramas, rotación y frescura.`,
    emoji: `🏪`,
    etiqueta: `PRÓXIMAMENTE`,
    gradiente1: `#1E7D4F`,
    gradiente2: `#0d4a2c`,
    duracionMin: 16,
    orden: 4,
    estado: `proximamente`,
    notaMinima: 60,
    insigniaIco: `🏪`,
    insigniaNombre: `Experto en Piso`,
    leccionesPrevistas: 3,
    preguntasPrevistas: 5,
    lecciones: [],
    preguntas: []
  };

export const CURSOS_BIMBO: Curso[] = [CURSO_TV, CURSO_PP, CURSO_EC, CURSO_NT];
